import React, { useEffect } from 'react';
import { Box } from 'rebass/styled-components';
import { Heading } from '../components';

function EngagementController() {
  const {
    REACT_APP_ENGAGEMENT_CONTROLLER_CDN_PATH,
  } = process.env;

  return (
    <Box width="100%" height="100%" display="flex" flexDirection="column">
      <Heading>Manage Rules</Heading>
      <iframe title="Engagement Controller" id="ec-frame" src={`${REACT_APP_ENGAGEMENT_CONTROLLER_CDN_PATH}/index.html`} style={{ height: '100%', width: '100%' }} />
    </Box>
  );
}

export default EngagementController;
